<template>
  <teleport to="body">
    <transition name="wmodal-fade">
      <div v-if="show" class="wmodal-overlay welfare-admin" @mousedown.self="onBackdrop">
        <div class="wmodal-box" :class="sizeClass" role="dialog" aria-modal="true">
          <div class="flex items-start justify-between gap-3 px-5 py-4 border-b border-gray-200">
            <div class="min-w-0">
              <h2 class="text-lg font-medium text-gray-800 break-words">{{ title }}</h2>
              <div v-if="subtitle" class="text-sm text-theme-37 mt-0.5 break-words">{{ subtitle }}</div>
            </div>
            <button type="button" class="w-8 h-8 rounded-md flex items-center justify-center text-theme-37 hover:bg-gray-100 flex-shrink-0" title="ปิด" @click="$emit('close')">
              <XIcon class="w-4 h-4" />
            </button>
          </div>
          <div class="wmodal-body px-5 py-4">
            <slot />
          </div>
          <div v-if="$slots.footer" class="px-5 py-3 border-t border-gray-200 bg-gray-50 rounded-b-md flex flex-wrap items-center justify-end gap-2">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { computed, watch, onBeforeUnmount } from "vue";

const props = defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: "" },
  subtitle: { type: String, default: "" },
  size: { type: String, default: "md" }, // sm | md | lg | xl
  closeOnBackdrop: { type: Boolean, default: false },
});
const emit = defineEmits(["close"]);

const sizeClass = computed(() => ({ sm: "max-w-md", md: "max-w-2xl", lg: "max-w-4xl", xl: "max-w-6xl" }[props.size] || "max-w-2xl"));
const onBackdrop = () => { if (props.closeOnBackdrop) emit("close"); };
const onKey = (e) => { if (e.key === "Escape" && props.show) emit("close"); };

watch(() => props.show, (v) => {
  if (v) { document.addEventListener("keydown", onKey); document.body.style.overflow = "hidden"; }
  else { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; }
}, { immediate: true });
onBeforeUnmount(() => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; });
</script>

<style scoped>
.wmodal-overlay {
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(15, 23, 42, 0.45);
  display: flex; align-items: flex-start; justify-content: center;
  padding: 3rem 1rem; overflow-y: auto;
}
.wmodal-box {
  width: 100%; background: #fff; border-radius: 0.5rem;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
  display: flex; flex-direction: column; max-height: calc(100vh - 6rem);
}
.wmodal-body { overflow-y: auto; }
.wmodal-fade-enter-active, .wmodal-fade-leave-active { transition: opacity 0.15s ease; }
.wmodal-fade-enter-from, .wmodal-fade-leave-to { opacity: 0; }
@media (max-width: 640px) {
  .wmodal-overlay { padding: 1rem 0.5rem; }
  .wmodal-box { max-height: calc(100vh - 2rem); }
}
</style>
